"use client";

import Plus from "@/assets/icon/plus.svg";
import { NewsContext, newsContextSchema, NewsListElement } from "@vereinsheim/backend-types/src/news";
import { NewsElement } from "@/app/pwa/components/news/NewsElement";
import Link from "next/link";
import {
  pwaNewsClubCreatePath, pwaNewsClubListPath,
  pwaNewsTeamCreatePath,
  pwaNewsTeamListPath
} from "@/utils/urlHelper";
import NoContent from "@/app/pwa/components/NoContent";
import { Card } from "@/app/pwa/components/Card";
import { subject } from "@casl/ability";
import { useAbility } from "@/app/pwa/lib/ability-context";

type NewsPageListProps = {
  newsList: NewsListElement[],
  displayAmount?: number,
  contextId: string,
  newsElementClassName?: string,
  newsContext: NewsContext
};

export function NewsPageList(
  {
    newsList,
    displayAmount,
    contextId,
    newsContext
  }: NewsPageListProps) {
  const ability = useAbility();

  return (
    <div>
      {newsList.length > 0
        ?
        newsList.slice(0, displayAmount ?? 50).map(n => (
          <Card className="mt-4 p-2" p={false} key={n._id}>
            <NewsElement news={n} listContext={newsContext} className="px-2" />
          </Card>
        ))
        :
        <NoContent className="flex-col">
          Keine News gefunden.<br />
          {ability.can("create", subject("News", { contextId, newsContext })) &&
            <Link className="button button--link-secondary"
                  href={newsContext == newsContextSchema.enum.Team ? pwaNewsTeamCreatePath(contextId) : pwaNewsClubCreatePath()}>News
              erstellen<Plus className="ml-blank" /></Link>
          }
        </NoContent>
      }
      {displayAmount && newsList.length > displayAmount &&
        <div className="border-t border-gray-150">
          <Link
            className="button button--link-secondary w-full justify-center"
            href={newsContext == newsContextSchema.enum.Team ? pwaNewsTeamListPath(contextId) : pwaNewsClubListPath()}
          >
            Alle News
          </Link>
        </div>
      }
    </div>
  );
}


